import { render } from "./CreateLearningGoal.vue?vue&type=template&id=7af23c3b"
import script from "./CreateLearningGoal.vue?vue&type=script&lang=js"
export * from "./CreateLearningGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__